var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-datepicker',{attrs:{"inline":"","indicators":"bars","events":_vm.sidebar.events},on:{"input":_vm.changeDate},model:{value:(_vm.sidebar.date),callback:function ($$v) {_vm.$set(_vm.sidebar, "date", $$v)},expression:"sidebar.date"}})}
var staticRenderFns = []

export { render, staticRenderFns }